import APResetImagePlaceholder from "./APResetImagePlaceholder";

export { APResetImagePlaceholder };

export default APResetImagePlaceholder;
